$(()=> {
    $('body').on('click', '.js-close-christmas-calendar-modal', function () {
        $('#christmas-calendar-modal').modal('hide');
    });

    $('.js-christmas-calendar-item-active').on('click', function (e) {
        let id = $(e.currentTarget).data('calendarItem');

        $.ajax({
            type: "POST",
            url: aw_christmas_item_is_active_ajax,
            data: {
                id_day: id
            },
            success: (data) => {
                if (data.success) {
                    if (typeof data.modal !== 'undefined') {

                        $('body').append(data.modal)
                        const $modal = $('#christmas-calendar-modal')

                        $modal
                            .on('hidden.bs.modal', () => {
                                $('body').removeClass('christmas-modal-open');
                                $modal.remove();
                            })
                            .modal('show');

                        $('body').addClass('christmas-modal-open');
                    }
                }
            }
        })
    })
})